import http from '@/util/http-common'

// Repeatable query params (e.g. status=Queued&status=Failed) instead of the
// axios default status[]=Queued&status[]=Failed which the API does not bind.
function serializeParams (params) {
  const search = new URLSearchParams()

  Object.keys(params || {}).forEach(key => {
    const value = params[key]

    if (value === null || value === undefined || value === '') {
      return
    }

    if (Array.isArray(value)) {
      value
        .filter(entry => entry !== null && entry !== undefined && entry !== '')
        .forEach(entry => search.append(key, entry))
      return
    }

    search.append(key, value)
  })

  return search.toString()
}

class DeviceCommandsDataService {
  // Full command history for a device + per-status totals
  // params: deviceId | macAddress, state, status[], type, from, to, page, pageSize
  getHistory (params = {}) {
    return http.get('/admin/device-commands', {
      params,
      paramsSerializer: serializeParams,
    })
  }

  // Only commands still awaiting the device
  getPending (params = {}) {
    return http.get('/admin/device-commands/pending', {
      params,
      paramsSerializer: serializeParams,
    })
  }

  // One command's detail
  get (commandId) {
    return http.get(`/admin/device-commands/${commandId}`)
  }

  // Cancel a single pending command
  cancel (commandId, data = {}) {
    return http.post(`/admin/device-commands/${commandId}/cancel`, data)
  }

  // Cancel listed ids, or every pending command for the device when
  // commandIds is empty (optionally narrowed by type)
  cancelMany (data) {
    return http.post('/admin/device-commands/cancel', data)
  }

  // Status / state vocabulary for the filter UI
  getStatuses () {
    return http.get('/admin/device-commands/statuses')
  }
}

export default new DeviceCommandsDataService()
